import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';

import s from './MLToggle.module.css';

const toggleStatus = (checked, disabled, disabledChecked) => {
  const status = {
    checked: false,
    disabled: false,
  };
  if (checked) status.checked = true;
  if (disabled) status.disabled = true;
  if (disabledChecked) {
    status.checked = true;
    status.disabled = true;
  }
  return status;
};

function MLToggle(props) {
  const { checked, disabled, disabledChecked, className, labelText, onChange, testId } = props;
  const toggleId = uuid();
  const status = toggleStatus(checked, disabled, disabledChecked);

  return (
    <div data-test-id={testId} className={`${s.container} ${className || ''}`}>
      <input
        role="switch"
        className={s.input}
        aria-checked={status.checked}
        checked={status.checked}
        disabled={status.disabled}
        onChange={onChange}
        onKeyPress={(e) => {
          if (e.key === 'Enter') onChange();
        }}
        id={toggleId}
        type="checkbox"
      />
      <label
        className={s.label}
        htmlFor={toggleId}
      >
        <div className={s.labelScreenreader}>{labelText}</div>
        <div aria-hidden="true" className={`${s.slider} ${s.round}`} />
      </label>
    </div>
  );
}

MLToggle.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledChecked: PropTypes.bool,
  className: PropTypes.string,
  labelText: PropTypes.string,
  testId: PropTypes.string,
  onChange: PropTypes.func,
};

export default MLToggle;
